import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FeatureFlagService } from '../../../../../core/shared/misc-services/feature-flag.service';
import {
  defaultPointSize,
  defaultShapeOpacity,
} from '../../../../../cross-team-shared/state/layer-settings-state-3d';
import { settingsStoreToken } from '../../../../../cross-team-shared/state/setting-state';

@Component({
  selector: 'h3-view-settings3d',
  templateUrl: './view-settings3d.component.html',
  styleUrl: './view-settings3d.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewSettings3dComponent {
  private readonly settingsStore =
    inject(settingsStoreToken)('layerSettings3d');
  private readonly featureFlagService = inject(FeatureFlagService);

  defaultLayerOpacity = defaultShapeOpacity;
  defaultPointSize = defaultPointSize;
  pointSizeConfig = {
    min: 1,
    max: 5,
    step: 0.1,
  };
  layerOpacityStore = this.settingsStore('opacity');
  pointSizeStore = this.settingsStore('pointSize');
  hasGroundingSettingsFeatureFlag =
    this.featureFlagService.hasFlag('grounding_settings');
}
